// src/pages/AdminAgendaCitas/components/CalendarPanel.tsx
import React from 'react';
import { Button, Calendar, DateBox } from 'devextreme-react';
import TagBox from 'devextreme-react/tag-box';
import { SysI_Agenda } from '../../../types/types.agendaCitas';
import './../AdminAgendaCitas.scss';
import { useScreenSize } from '../../../utils/media-query';

interface CalendarPanelProps {
  currentDate: Date;
  onDateChange: (date: Date) => void;
  agendas: SysI_Agenda[];
  selectedAgendaIds: number[];
  onAgendaSelectionChange: (ids: number[]) => void;
  onCreateAppointment: () => void;
  canCreateAppointment: Boolean | any;
}

const  CalendarPanel: React.FC<CalendarPanelProps> = ({ currentDate, onDateChange, agendas, selectedAgendaIds, onAgendaSelectionChange, onCreateAppointment, canCreateAppointment }) => {
  const { isSmall, isXSmall, isMedium, isLarge } = useScreenSize();

  // Manejar cambios en la selección de agendas
  const handleAgendaToggle = (agendaId: number) => {
    if (selectedAgendaIds.includes(agendaId)) {
      onAgendaSelectionChange(selectedAgendaIds.filter((id) => id !== agendaId));
    } else {
      onAgendaSelectionChange([...selectedAgendaIds, agendaId]);
    }
  };

  // Manejar selección/deselección de todas las agendas
  const handleSelectAll = () => {
    if (selectedAgendaIds.length === agendas.length) {
      onAgendaSelectionChange([]);
    } else {
      onAgendaSelectionChange(agendas.map((a) => a.Ag_Id));
    }
  };

  // Función para truncar el nombre
  const truncate = (str: string, n: number) => (str.length > n ? str.slice(0, n) + '...' : str);

  return (
    <div className='calendar-panel'>
      <div className='buttons-container'>
        <Button text='HOY' onClick={() => onDateChange(new Date())} className='toolbar-button today-button' />
        {canCreateAppointment && <Button text='CREAR CITA' type='default' onClick={onCreateAppointment} className='toolbar-button create-button' />}
      </div>

      <div className='calendar-container'>
        {
          isSmall || isXSmall ? (
            <div className='date-picker-container'>
              <DateBox value={currentDate} onValueChanged={(e) => onDateChange(e.value)} />
            </div>
          ) : (
            <Calendar
              value={currentDate}
              onValueChanged={(e) => onDateChange(e.value)}
              firstDayOfWeek={1}
              showTodayButton={false}
            />
          )
        }
      </div>

      <div className='agendas-container'>
        <h4>Mis Agendas</h4>
        {!isSmall && !isXSmall && (isMedium || isLarge) && (
        <div className='select-all'>
          <input type='checkbox' checked={selectedAgendaIds.length === agendas.length && agendas.length > 0} onChange={handleSelectAll} id='select-all-agendas' />
          <label htmlFor='select-all-agendas'>Seleccionar todas</label>
        </div>
        )}

        {/* En pantallas pequeñas, usar TagBox multiselect para agendas */}
        {isSmall || isXSmall ? (
          <TagBox
            items={agendas}
            value={selectedAgendaIds}
            valueExpr={'Ag_Id'}
            displayExpr={item => item ? (item.Ag_Nombre.length > 18 ? item.Ag_Nombre.slice(0, 18) + '...' : item.Ag_Nombre) : ''}
            onValueChanged={e => onAgendaSelectionChange(e.value)}
            showSelectionControls={true}
            showMultiTagOnly={false}
            placeholder='Selecciona agendas...'
            searchEnabled={true}
            noDataText='Sin agendas'
            maxDisplayedTags={2}
            style={{ width: '100%', marginTop: 8, marginBottom: 8 }}
          />
        ) : (
          <div className='agenda-list'>
            {agendas.map((agenda) => (
              <div key={agenda.Ag_Id} className='agenda-item'>
                <input type='checkbox' id={`agenda-${agenda.Ag_Id}`} checked={selectedAgendaIds.includes(agenda.Ag_Id)} onChange={() => handleAgendaToggle(agenda.Ag_Id)} />
                <div className='agenda-color' style={{ backgroundColor: agenda.Ag_Color || '#ccc' }}></div>
                <label htmlFor={`agenda-${agenda.Ag_Id}`}>{agenda.Ag_Nombre}</label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarPanel;
